import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import App from './components/App'
import Home from './containers/Home'
import Category from './containers/Category'
import FeaturedLists from './containers/FeaturedLists'
import Featured from './containers/Featured'
import MyList from './containers/MyList'
// import Catalog from './containers/Catalog'
// import Item from './containers/Item'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import configureStore from './configureStore'

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)

render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={App}>
        <IndexRoute component={Home} />
        <Route path="/categories/:categorySlug" component={Category} />
        <Route path="/categories/:categorySlug/items/:itemId" component={Category} />
        <Route path="/mylist" component={MyList} />
        <Route path="/features/:featureId" component={Category} />
        <Route path="/features/:featureId/items/:itemId" component={Category} />
        {/* <Route path="/catalogs/:catalogId" component={Catalog} />
        <Route path="/catalogs/:catalogId/items/:itemId" component={Item} /> */}
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
)

require('./styles.scss')

window.onerror = function(message, url, lineNum) {
  console.log('report fatal error');
  ga("send", "exception", {
    "exDescription": message,
    'exFatal': false
  });
};



// WEBPACK FOOTER //
// ./src/app.js